// material-ui
import Box from '@mui/material/Box';

// logo (máscara): a forma vem do SVG e a COR vem do tema (primary.main),
// então acompanha automaticamente dark/light e o preset de cor escolhido.
import markUrl from 'assets/images/logo/familia-mark.svg';

// ==============================|| LOGO (sidebar aberta) — marca + nome ||============================== //

export default function LogoMain({ reverse }: { reverse?: boolean }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '100%', px: 1.5 }}>
      <Box
        aria-label="Família"
        sx={{
          width: 40,
          height: 40,
          flexShrink: 0,
          backgroundColor: reverse ? 'common.white' : 'primary.main',
          WebkitMaskImage: `url(${markUrl})`,
          maskImage: `url(${markUrl})`,
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          WebkitMaskPosition: 'center',
          maskPosition: 'center'
        }}
      />
      <Box
        component="span"
        sx={{ fontWeight: 700, fontSize: '1.15rem', letterSpacing: 0.3, color: reverse ? 'common.white' : 'text.primary' }}
      >
        Família
      </Box>
    </Box>
  );
}
